import React from 'react';
import useButtonState, {ApiDeleteButtonProps} from './state';
import CircleButton from '../circle-button';
import {RiDeleteBin4Line} from 'react-icons/ri';

const ApiDeleteButton: React.FC<ApiDeleteButtonProps> = (props) => {
  const {isLoading, handleRequest} = useButtonState(props);

  return (
    <CircleButton
      tooltip="Remover"
      icon={<RiDeleteBin4Line />}
      onClick={(e: Event) => {
        handleRequest(props.field!);
        e.stopPropagation();
      }}
      loading={isLoading}
    />
  );
};

export default ApiDeleteButton;
